export default __webpack_public_path__ + "static/flag.mexico-228bc36483e0f326a1b06114c0ed66d5.svg";